function addObserverIfDesiredNodeAvailable() {
  const targetNode = document.getElementsByClassName('yotpo-main-widget')[0];
  const config = { attributes: true, childList: true, subtree: true };

  if(targetNode) {

    const observer = new MutationObserver((mutationsList, observer) => {
      if ($('.yotpo-nav-tab[data-type="reviews"]').length <= 0) {
        window.setTimeout(addObserverIfDesiredNodeAvailable,500);
        return;
      }

      $('.yotpo-nav-tab[data-type="reviews"]').find('.yotpo-nav-wrapper').prepend(`<span class="yotpo-product-name">${$('.yotpo-main-widget').attr('data-name')}</span>`);

      observer.disconnect();
    });

    observer.observe(targetNode, config);
  }
}

addObserverIfDesiredNodeAvailable();

/*
const targetNode = document.getElementById('yotpo-main-widget');
const config = { attributes: true, childList: true, subtree: true };

if (targetNode) {
  const observer = new MutationObserver((mutationsList, observer) => {
    $('.yotpo-nav-wrapper')
      .eq(0)
      .prepend(`<span class="yotpo-product-name">${$('#yotpo-main-widget').attr('data-name')}</span>`);
    observer.disconnect();
  });

  observer.observe(targetNode, config);
}
*/
